/* Components */
import Vue from 'vue';

import arrow from './arrow.vue';
Vue.component('Arrow', arrow);

import MetaHeader from './metaheader.vue';
Vue.component('MetaHeader', MetaHeader);

import KioskStories from './kiosk.vue';
Vue.component('KioskStories', KioskStories);

import PennLogo from './pennlogo.vue';
Vue.component('PennLogo', PennLogo);

import blobs from './blobs.vue';
Vue.component('blobs', blobs);

import NavigationBar from './navigationbar.vue';
Vue.component('NavigationBar', NavigationBar);

import ListeningLabLogo from './listeninglablogo.vue';
Vue.component('ListeningLabLogo', ListeningLabLogo);

import mainfooter from './mainfooter.vue';
Vue.component('MainFooter', mainfooter);

import playlist from './playlist.vue';
Vue.component('PlayList', playlist);

import searchComponent from './search.vue';
Vue.component('searchComponent', searchComponent);

import searchResults from './results.vue';
Vue.component('searchResults', searchResults);

import magnifyingGlass from './magnifyingglass.vue';
Vue.component('magnifyingGlass', magnifyingGlass);

import veil from './veil.vue';
Vue.component('veil', veil);

import play from './play.vue';
Vue.component('play', play);

import player from './player.vue';
Vue.component('player', player);

import heart from './heart.vue';
Vue.component('heart', heart);

import sharethisstory from './sharethisstory.vue';
Vue.component('sharethisstory', sharethisstory);

import close from './close.vue';
Vue.component('close', close);

import heading from './heading.vue';
Vue.component('heading', heading);

import srcset from './srcset.vue';
Vue.component('srcset', srcset);

import guides from './guides.vue';
Vue.component('guides', guides);

import duration from './duration.vue';
Vue.component('duration', duration);

import tags from './tags.vue';
Vue.component('tags', tags);

import gallery from './gallery.vue';
Vue.component('gallery', gallery);

import pill from './pill.vue';
Vue.component('pill', pill);

import topicals from './topicals.vue';
Vue.component('topicals', topicals);

import hamburger from './hamburger.vue';
Vue.component('hamburger', hamburger);

import buttonBlock from './button.vue';
Vue.component('buttonBlock', buttonBlock);

import playlistStory from './playlistStory.vue';
Vue.component('playlistStory', playlistStory);

import imageloader from './imageloader.vue';
Vue.component('imageloader', imageloader);

import subscribe from './subscribe.vue';
Vue.component('subscribe', subscribe);
